import { useCollectionFilterQueryParamsContext } from '../../../../../../../brunswick/containers/CollectionFilterQueryParamsContext'
import { FilterModalService } from '../containers/FilterModalService'

import { FilterModalContent } from './FilterModalContent'
import { HiddenCrawlableFilterModalContent, StyledAriakitDialog } from './styles'

export const FilterModal = () => {
  const { closeFilterModal, shouldDisplayFilterModal, dialogStore } =
    FilterModalService.useContainer()
  const { clearAllFilters, selectedFilters, totalNumberOfSelectedFilterValues } =
    useCollectionFilterQueryParamsContext()

  /**
   * Note: When FilterModal is collapsed we still want to render its content (hidden) to
   * make it crawlable on page load.
   */
  if (!shouldDisplayFilterModal) {
    return (
      <HiddenCrawlableFilterModalContent>
        <FilterModalContent
          clearAllFilters={clearAllFilters}
          closeFilterModal={closeFilterModal}
          selectedFilters={selectedFilters}
          totalNumberOfSelectedFilterValues={totalNumberOfSelectedFilterValues}
        />
      </HiddenCrawlableFilterModalContent>
    )
  }

  return (
    <StyledAriakitDialog onClose={closeFilterModal} store={dialogStore} unmountOnHide>
      <FilterModalContent
        clearAllFilters={clearAllFilters}
        closeFilterModal={closeFilterModal}
        selectedFilters={selectedFilters}
        totalNumberOfSelectedFilterValues={totalNumberOfSelectedFilterValues}
      />
    </StyledAriakitDialog>
  )
}
